<style lang="less">
  @import "./main.less";
</style>
<template>
  <div class="main" :class="{'main-hide-text': shrink}">
    <div class="sidebar-menu-con" :style="{width: shrink?'60px':'200px', overflow: shrink ? 'visible' : 'auto'}">

      <shrinkable-menu :shrink="shrink" :menu-list="menuList" theme="dark">
        <div slot="top" class="logo-con">
          <img src="../styles/images/logo.png" />
        </div>
      </shrinkable-menu>

    </div>
    <div class="main-header-con" :style="{paddingLeft: shrink?'60px':'200px'}">
      <div class="main-header">
        <div class="navicon-con">
          <Button :style="{transform: 'rotateZ(' + (this.shrink ? '-90' : '0') + 'deg)'}" type="text" @click="toggleClick">
            <Icon type="navicon" size="32"></Icon>
          </Button>
        </div>
        <div class="header-avator-con">
          <div class="user-dropdown-menu-con">
            <Row type="flex" justify="end" align="middle" class="user-dropdown-innercon">
              <Dropdown transfer trigger="click" @on-click="handleClickUserDropdown">
                <a href="javascript:void(0)">
                  <span class="main-user-name">{{ user.name }}</span>
                  <Icon type="arrow-down-b"></Icon>
                </a>
                <DropdownMenu slot="list">
                  <DropdownItem name="loginout" divided>退出登录</DropdownItem>
                </DropdownMenu>
              </Dropdown>
              <Avatar icon="person" style="background: #619fe7;margin-left:10px;"></Avatar>
            </Row>
          </div>
        </div>
      </div>
    </div>
    <div class="single-page-con" :style="{left: shrink?'60px':'200px'}">
      <div class="single-page">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
  import shrinkableMenu from './main-components/shrinkable-menu/shrinkable-menu.vue';
  import {mapState} from 'vuex'
  import * as types from '../store/mutation-types'

  export default {
    components: {
      shrinkableMenu
    },
    data() {
      return {
        shrink: false
      };
    },
    computed: {
      ...mapState({
        user: state => state.user.user,
        menuList: state => state.app.menuList,
        //loading: state => state.main_loading
      })
    },
    methods: {
      toggleClick() {
        this.shrink = !this.shrink;
      },
      handleClickUserDropdown(name) {
        this.$store.commit(types.LOGOUT)

        this.$router.push({
          name: 'login'
        });
      }
    },
    mounted() {
    }
  };
</script>


// WEBPACK FOOTER //
// src/views/Main.vue